import script from "./TemplatesFloatingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplatesFloatingModal.vue?vue&type=script&setup=true&lang=ts"

import "./TemplatesFloatingModal.vue?vue&type=style&index=0&id=9e835f9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e835f9c"]])

export default __exports__